import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import { useFormikContext } from 'formik';
import Select, { createFilter } from 'react-select';
import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';

import useInput from '@febos-io/design/src/hooks/useInput';

import { useTranslation } from '../../hooks';
import usePatientSearch from '../../hooks/usePatientSearch';
import ButtonAddNewPatient from './ButtonAddNewPatient';
import PatientOption from './PatientOption';
import { getPatientList } from '../../store';

export function FormikSelectPatient({
  id: defaultId,
  label,
  name,
  placeholder = '',
  className,
  icon,
  // swap = false,
  // iconProps = {},FO
  resetFields = [],
  isModal,
  isNotAddNewPatient,
}) {
  // const [meta] = useField(name);
  const { t, } = useTranslation();
  const { values, setValues, } = useFormikContext();
  const { id, } = useInput(defaultId, label, icon);
  const patients = useSelector(getPatientList);

  const inputRef = useRef();

  // Usar el hook personalizado para la búsqueda de pacientes
  const { loading, searchPatients, } = usePatientSearch();

  const onChange = useCallback(
    (element) => {
      if (!element) {
        setValues({
          ...values,
          [name]: null,
        });
        return;
      }
      const patientSelected = patients.find((item) => item.id === element.id);
      const {
        id: patientId,
        birthDate,
        identificationNumber,
        lastName,
        name: patientName,
        email,
        gender,
        source,
      } = patientSelected || element;
      setValues({
        ...values,
        [name]: {
          id: patientId,
          birthDate,
          identificationNumber,
          lastName,
          name: patientName,
          email,
          gender,
          source,
        },
        ...resetFields.reduce(
          (cleared, resetField) => ({
            ...cleared,
            ...(values[resetField] && { [resetField]: '', }),
          }),
          {}
        ),
      });
    },
    [name, patients, resetFields, setValues, values]
  );

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: 'any',
    stringify: ({ data, }) => {
      return [
        data.name,
        data.middleName,
        data.lastName,
        data.motherLastName,
        data.email,
        data.identificationNumber,
      ].join(' ');
    },
  };
  const handleSearchPatient = (inputEvent) =>{
    // Teclas que no deben disparar la búsqueda
    const ignoredKeys = [
      'Enter',
      'ArrowDown',
      'ArrowUp',
      'ArrowLeft',
      'ArrowRight',
      'ShiftRight',
      'ShiftLeft',
      'CapsLock',
      'Tab',
      'Escape',
      'ControlLeft',
      'MetaLeft',
      'Space',
      'AltLeft',
      'AltRight',
    ];

    if (ignoredKeys.includes(inputEvent.code)) {
      return;
    }
    searchPatients(inputRef.current.props.inputValue);
  };

  return (
    <div className={className}>
      <label htmlFor={id} className="form-label">
        {label}
      </label>
      <Select
        onKeyDown={debounce(handleSearchPatient, 500)}
        ref={inputRef}
        defaultValue={values.patient}
        filterOption={createFilter(filterConfig)}
        getOptionLabel={(option) => [option.name, option.middleName, option.lastName, option.motherLastName].join(' ')
        }
        getOptionValue={(option) => option.id}
        options={patients}
        loadingMessage={() => `${t('Searching')}...`}
        noOptionsMessage={() => t('No options')}
        id={id}
        placeholder={placeholder}
        onChange={onChange}
        // fixme: when change the value the input lost the focus
        // components={{ Control }}
        components={{
          ...(!isNotAddNewPatient && {
            Menu: ButtonAddNewPatient,
          }),
          Option: PatientOption,
        }}
        className="react-select-container"
        classNamePrefix="react-select"
        isClearable
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: isModal ? 9999 : 1,
          }),
        }}
        menuShouldScrollIntoView={false}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        isLoading={loading}
      />
    </div>
  );
}

FormikSelectPatient.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  // loading: PropTypes.bool,
  icon: PropTypes.string,
  // swap: PropTypes.bool,
  // iconProps: PropTypes.object,
  className: PropTypes.string,
  resetFields: PropTypes.array,
  isModal: PropTypes.bool,
  isNotAddNewPatient: PropTypes.bool,
};

export default FormikSelectPatient;
